import { validationRules } from "./validation_rules.js";
import { addError,eventError } from "./adobeAnalytics.js";

export function validateMask(e, newValue, type) {
  let isValid = true;
  // First check if field is empty.
  if (e.classList.contains("is-invalid") && newValue !== "") {
    e.classList.add("is-valid");
    e.classList.remove("is-invalid");
  } else if (newValue == "") {
    isValid = false;
    if(e.classList.contains("is-valid")){
      e.classList.add("is-invalid");
      e.classList.remove("is-valid");
    }
  }
  
  let mask;
  // Build Mask
  if(type==="email") {mask = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;}
  else if(type==="creditcard") {
    newValue=newValue.replace(/-/g, "");
    newValue=newValue.replace(/\s/g, "");
    mask= /^\d{4}([\ \-]?)\d{4}\1\d{4}\1\d{4}$/;
  }
  else if(type==="postalcode") {
    if(document.getElementById('province').value==="Alberta"||
      document.getElementById('province').value==="AB"){mask = /^[Tt]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="British Colombia"||
      document.getElementById('province').value==="BC"||
      document.getElementById('province').value==="Colombie-Britannique"){mask = /^[Vv]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Manitoba"||
      document.getElementById('province').value==="MB"){mask = /^[Rr]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="New Brunswick"||
      document.getElementById('province').value==="Nouveau-Brunswick"||
      document.getElementById('province').value==="NB"){mask = /^[Ee]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Newfoundland and Labrador"||
      document.getElementById('province').value==="Terre-Neuve-et-Labrador"||
      document.getElementById('province').value==="NL"){mask = /^[Aa]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Nova Scotia"||
      document.getElementById('province').value==="Nouvelle-Écosse"||
      document.getElementById('province').value==="NS"){mask = /^[Bb]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Northwest Territories"||
      document.getElementById('province').value==="Territoires du Nord-Ouest"||
      document.getElementById('province').value==="NT"){mask = /^[Xx]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Nunavut"||
      document.getElementById('province').value==="NU"){mask = /^[Xx]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Ontario"||
      document.getElementById('province').value==="ON"){mask = /^[KLMNPklmnp]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Prince Edward Island"||
      document.getElementById('province').value==="Île-du-Prince-Édouard"||
      document.getElementById('province').value==="PE"){mask = /^[Cc]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Quebec"||
      document.getElementById('province').value==="Québec"||
      document.getElementById('province').value==="QC"){mask = /^[GHJghj]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if(document.getElementById('province').value==="Saskatchewan"||
      document.getElementById('province').value==="SK"){mask = /^[Ss]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else if (document.getElementById('province').value==="Yukon"||
      document.getElementById('province').value==="YT"){mask = /^[Yy]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
    else {mask = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;}
  }
  else if(type==="phone") {
    // mask = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    mask = /^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/;
  } else if(type==="expiry"){
    mask = /^([1-9]|0[1-9]|1[0-2])\/?(20[0-9]{2}|[0-9]{2})$/;
  }

  // Check if new Value matches mask
  if (mask.test(String(newValue)) === false) {
    isValid = false;
    if(e.classList.contains("is-valid")){
      e.classList.add("is-invalid");
      e.classList.remove("is-valid");
    }
  }
  return isValid;
}

export function validateSelect(e, newValue) {
  let isValid = true;
  if (e.classList.contains("is-invalid") && newValue !== "") {
    e.classList.remove("is-invalid");
    e.classList.add("is-valid");
  }
  if (newValue === null || newValue === "") {
    isValid = false;
    e.classList.add("is-invalid");
    e.classList.remove("is-valid");
  }
  return isValid;
}

export function validateToggle(e, validState) {
  let isValid = true;
  if (e.classList.contains("is-invalid") && e.value == "true") {
    e.classList.remove("is-invalid");
    e.classList.add("is-valid");
  } else if (e.checked !== validState) {
    isValid = false;
    e.nextSibling.classList.remove("is-valid");
    e.nextSibling.classList.add("is-invalid");
    e.classList.add("is-invalid");
    e.classList.remove("is-valid");
  }
  return isValid;
}

export function validateRadio(e, validState, oneofgroup) {
  let isValid = false;
  // If oneofgroup rule is set (meaning specific check isn't required, just one of the group)
  if(oneofgroup===true) {
    for(let i=0; i<document.getElementsByName(e.name).length; i++){
      if(document.getElementsByName(e.name)[i].checked===true){isValid=true}
    }
  } 
  // Check if specific required radio is checked.
  else if(e.checked === validState) {isValid=true;}

  // Is this field marked as invalid, but is now valid?
  if (
    e.parentNode.parentNode.classList.contains("is-invalid") &&
    isValid===true
  ) {
    e.parentNode.parentNode.classList.remove("is-invalid");
    e.parentNode.parentNode.classList.add("is-valid");
  } else if (isValid===false) {
    e.parentNode.parentNode.classList.remove("is-valid");
    e.parentNode.parentNode.classList.add("is-invalid");
  }
  return isValid;
}

export function validateCheckbox(e, newValue) {
  let isValid = true;
  if (e.parentNode.parentNode.classList.contains("is-invalid")||e.parentNode.parentNode.classList.contains("is-valid")) {
    if (newValue === true) {
      e.parentNode.parentNode.classList.remove("is-invalid");
      e.parentNode.parentNode.classList.add("is-valid");
    } else {
      isValid = false;
      e.parentNode.parentNode.classList.remove("is-valid");
      e.parentNode.parentNode.classList.add("is-invalid");
    }
  }
  return isValid;
}

export function validateDate(e, newValue) {
  let isValid = true;

  const rawElementValue = e && typeof e.value === "string" ? e.value : "";
  let value = rawElementValue || "";

  if (!value) {
    if (newValue instanceof Date) {
      value = newValue.toISOString();
    } else if (typeof newValue === "string") {
      value = newValue;
    }
  }

  const trimmedValue = (value || "").trim();
  if (!trimmedValue) {
    isValid = false;
  }

  if (isValid && trimmedValue.includes("/")) {
    const month = trimmedValue.substring(0, 2);
    const day = trimmedValue.substring(3, 5);
    if (month === "00" || day === "00" || Number(month) > 12) {
      isValid = false;
    }
  }

  if (isValid) {
    const parseTarget = newValue instanceof Date ? newValue.toISOString() : trimmedValue;
    if (!parseTarget || Number.isNaN(Date.parse(parseTarget))) {
      isValid = false;
    }
  }

  if (e && (e.classList.contains("is-invalid") || e.classList.contains("is-valid"))) {
    if (isValid) {
      e.classList.remove("is-invalid");
      e.classList.add("is-valid");
    } else {
      e.classList.remove("is-valid");
      e.classList.add("is-invalid");
    }
  }

  return isValid;
}

export function validateString(e, newValue, minlength = 0) {
  let isValid = true;
  if (e.classList.contains("is-invalid") && newValue != "") {
    e.classList.remove("is-invalid");
    e.classList.add("is-valid");
  } else if (newValue == "") {
    isValid = false;
    if(e.classList.contains("is-valid")){
      e.classList.remove("is-valid");
      e.classList.add("is-invalid");
    }
  }
  if (newValue.length < minlength && minlength != "0") {
    isValid = false;
    if(e.classList.contains("is-valid")){
      e.classList.remove("is-valid");
      e.classList.add("is-invalid");
    }
  }
  return isValid;
}

export function validateForm(rules) {
  // Validate all inputs and selects on the screen.
  
  const myList = document.querySelectorAll("input,select");
  let isValid = true;
  // Don't send out indivdual error events to analytics.
  window.squelchErrors=true;
  for (const x of myList) {
    // Skip any inputs/selects that are disabled or are not currently visible.
    if (rules[x.id]) {
      let bypass=false;
      // This rule is needed to validate hidden fields if they are mirrored. (Used for using a different field in mobile view)
      if (rules[x.id]["mirrored"]&&document.getElementById(rules[x.id]["mirrored"])&&document.getElementById(rules[x.id]["mirrored"]).offsetParent!==null) {
        bypass=true;
      }
      if ((!x.disabled && x.offsetParent !== null)||bypass===true) {
        //Set this field as initially valid
        if(rules[x.id]["type"]==="checkbox"){
          x.parentNode.parentNode.classList.add("is-valid");
        }
        else if (x.type === "checkbox") {
          x.classList.add("is-valid");
          
        } else if (x.type === "radio") {
          x.parentNode.parentNode.classList.add("is-valid");
        } else {
          x.classList.add("is-valid");
        }
        x.setAttribute("aria-invalid","false");
        
        if(rules[x.id]["type"]==="checkbox"){
          if(!validateField(x, x.checked, rules)) isValid = false;
        }
        else {
          if(!validateField(x, x.value, rules)) isValid = false;
        }
      }
    }
  }
  window.squelchErrors=false;
  if(isValid===false){
    eventError();
  }
  return isValid;
}

export function setError(targetField, errorMsg="", errorCode="") {
  const targetLabel = document.querySelector(
    'span[for="' + targetField.id + '"]'
  );
  if (targetLabel) {
    if(errorMsg===""){
      targetLabel.innerHTML = errorMsg;
      targetLabel.classList.add("feedback");
      targetLabel.classList.remove("invalid-feedback");
    }
    else {
      targetLabel.innerHTML = errorMsg;
      targetLabel.classList.remove("feedback");
      targetLabel.classList.add("invalid-feedback");

      // Track error in Analytics.
      addError(targetField.id, errorCode, 'invalid');
    }
  }
}

export function validateField(targetField, newValue, rules) {
  // This function checks the provided field to see it is valid.
  let isValid = true;
  // Hide error message
  if (document.querySelector('span[for="' + targetField.id + '"]') !== null) {
    document
      .querySelector('span[for="' + targetField.id + '"]')
      .classList.remove("invalid-feedback");
      document
      .querySelector('span[for="' + targetField.id + '"]')
      .classList.add("feedback");
      document
      .querySelector('span[for="' + targetField.id + '"]')
      .innerHTML="";
  }

  // If there are no rules for this field, it is valid.
  if (typeof rules[targetField.id] !== "undefined") {

    // Check if rule to "require if field == value"
    let forceRequired = false;
    if (rules[targetField.id]["requirediffield"] !== undefined) {
      if(
        (document.getElementById(rules[targetField.id]["requirediffield"]).type==="checkbox"&&document.getElementById(rules[targetField.id]["requirediffield"]).checked === rules[targetField.id]["requiredifvalue"])||
        (document.getElementById(rules[targetField.id]["requirediffield"]).type!=="checkbox"&&document.getElementById(rules[targetField.id]["requirediffield"]).value === rules[targetField.id]["requiredifvalue"])
        ){
        forceRequired = true;
      }  
    }
  
    // Check for required rule
    if (rules[targetField.id]["required"] === true || forceRequired === true) {
      if (rules[targetField.id]["type"] === "date") {
        if (!validateDate(targetField, newValue)) {
          isValid = false;
        }
      } else if (rules[targetField.id]["type"] === "select") {
        if (!validateSelect(targetField, newValue)) {
          isValid = false;
        }
      } else if (rules[targetField.id]["type"] === "email"||rules[targetField.id]["type"] === "phone"||rules[targetField.id]["type"] === "postalcode"||rules[targetField.id]["type"] === "creditcard"||rules[targetField.id]["type"] === "expiry") {
        if (!validateMask(targetField, newValue,rules[targetField.id]["type"])) {
          isValid = false;
        }
      } else if (rules[targetField.id]["type"] === "string") {
        let minlength = 0;
        if (rules[targetField.id]["minlength"])
          minlength = rules[targetField.id]["minlength"];
        if (!validateString(targetField, newValue, minlength)) {
          isValid = false;
        }
      } else if (rules[targetField.id]["type"] === "toggle") {
        if (!validateToggle(targetField, rules[targetField.id]["required"])) {
          isValid = false;
        }
      } else if (rules[targetField.id]["type"] === "radio") {
        if (!validateRadio(targetField, rules[targetField.id]["required"],rules[targetField.id]["oneofgroup"])) {
          isValid = false;
        }
      } else if (rules[targetField.id]["type"] === "checkbox") {
        if (!validateCheckbox(targetField, newValue, rules[targetField.id]["required"])) {
          isValid = false;
        }
      }
      
      if (isValid == false) {
        // If this field shares an error status with another field
        if (rules[targetField.id]["shareerror"]) {
          /*let sharedField = document.getElementById(
            rules[targetField.id]["shareerror"]
          );*/
          // Mark the other field as invalid
          document
            .getElementById(rules[targetField.id]["shareerror"])
            .classList.add("is-invalid");
          document
            .getElementById(rules[targetField.id]["shareerror"])
            .classList.remove("is-invalid");
        }
        
        
        if(
          // If this field shares an error message, check that the error message isn't flagged
          !(rules[targetField.id]["onlyone"]&&document.querySelector('span[for="' + rules[targetField.id]["onlyone"] + '"]').classList.contains("invalid-feedback"))&&
          (targetField.classList.contains('is-invalid')||rules[targetField.id]["type"]==='radio'||rules[targetField.id]["type"]==='checkbox')
        ){
          setError(targetField, rules[targetField.id]["requirederror"], rules[targetField.id]["errorcode"]);
        }

      }
    }
    // Set Aria-Invalid
    if(isValid===true){
      targetField.setAttribute("aria-invalid","false");
    }
    else {
      targetField.setAttribute("aria-invalid","true");
    }

    // If this field has a function attached, execute it:
    if (rules[targetField.id]["aftererror"] !== undefined) {
      rules[targetField.id]["aftererror"]();
    }

    // If this is an "Only One" field, set the error message on the other field if it is invalid.
    if(
      isValid===true&&
      rules[targetField.id]["onlyone"]&&
      document.getElementById(rules[targetField.id]["onlyone"]).classList.contains("is-invalid")
    ) {
      setError(document.getElementById(rules[targetField.id]["onlyone"]), rules[targetField.id]["requirederror"], rules[targetField.id]["errorcode"]);
    }

    // Mirror the invalid/valid state to another input
    if (rules[targetField.id]["mirrored"]) {
      mirrorStatus(targetField.id,rules[targetField.id]["mirrored"]);
    }
  }
  return isValid;
}

// This function causes validation to start on blur, instead of waiting until the entire form is validated once when navigating to next page.
export function callValidationStatusOnBlur(){
  const fields = document.querySelectorAll('input,select');
  for(const field of fields)
  {
    if(field.type!=="checkbox"&&field.parentNode.parentNode.classList.contains("vdp-datepicker")===false){
      field.addEventListener("blur", (e) => {
        e.target.classList.add("is-valid");
        validateField(e.target, e.target.value, validationRules());
      });
    }
  }
}

export function mirrorStatus(from, to){
  if(document.getElementById(from).classList.contains('is-invalid')){
    document.getElementById(to).classList.add('is-invalid');
    document.getElementById(to).classList.remove('is-valid');
  }
  else if(document.getElementById(from).classList.contains('is-valid')){
    document.getElementById(to).classList.remove('is-invalid');
    document.getElementById(to).classList.add('is-valid');
  }
}
